import {
	FormItem,
	ReorderableList,
	Select,
	SelectOption,
	TextInput,
	ValidationError
} from "client/Components";
import { IInputAttachable, IValueInputAttachable } from "client/Forms/attachable";
import { useCallback } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { ZaaksysteemResourceKind } from "client/Api/Workspace/LiveInformation/Zaaksysteem/zaaksysteemLiveInformation";
import { UpdateZaaksysteemTabModel } from "client/Api/Workspace/workspace";


const tabKindOptions: readonly SelectOption<ZaaksysteemResourceKind>[] = [
	{ text: localize("_MyOpenCases"), value: ZaaksysteemResourceKind.MyOpenCases },
	{ text: localize("_MySuspendedCases"), value: ZaaksysteemResourceKind.MySuspendedCases }
];

type EditZaaksysteemTabItemProps = {
	attachable: IValueInputAttachable<UpdateZaaksysteemTabModel>;
	onRemoveTab: () => void;
};

export const EditZaaksysteemTabItem = (props: EditZaaksysteemTabItemProps) => {
	const { attachable, onRemoveTab } = props;
	const nameAttachable: IInputAttachable<string> = attachable.for("name");

	const resourceKindChangeHandler = useCallback(
		(newValue: ZaaksysteemResourceKind | null): void => {
			if (newValue !== attachable.value.resourceKind) {
				const onChange: (newValue: string) => void = nameAttachable.attachToTextInput()
					.onChange;

				const nameValue: string = tabKindOptions.find(
					(option) => option.value === newValue
				)
					?.text ?? "";

				onChange(nameValue);
			}
		},
		[
			nameAttachable,
			attachable.value
				.resourceKind
		]
	);

	return (
		<ReorderableList.PanelItem
			{...attachable.attachToReorderableListPanelItem(true)}
			header={
				<Select
					{...attachable
						.for("resourceKind")
						.attachToSelect()
						.withOnChange(resourceKindChangeHandler)}
					options={tabKindOptions}
					placeholder={localize("_PleaseSelect")}
					menuTitle={localize("_Source")}
				/>
			}
			onRemove={onRemoveTab}
		>
			<ValidationError
				{...attachable.for("resourceKind")
					.attachToValidationError()}
			/>
			<FormItem
				label={localize("_TabName")}
			>
				<TextInput
					{...nameAttachable.attachToTextInput()}
				/>
				<ValidationError
					{...nameAttachable.attachToValidationError()}
				/>
			</FormItem>
		</ReorderableList.PanelItem>
	);
};

EditZaaksysteemTabItem.displayName = "EditYammerTabItem";